import React from 'react'
import { useSelector } from 'react-redux'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import { convertToLocalDate, getTime } from 'srcReact/helpers/datetimeHelper'
import Avatar from 'srcReact/components/common2/Avatar'
import Icon from 'srcReact/components/icons/Icon'
import IconButton from 'srcReact/components/common2/IconButton'
import { useDispatch } from 'react-redux'
import { messengerActions } from 'srcReact/MessengerPage'

export default function ReplyingToMessage({
  messageObj,
  messageContainerCSS,
  originMessageContainerCSS,
  scrollToTarget
}) {
  const { t } = useTranslation()

  const dispatch = useDispatch()

  const {
    message: { createdAt },
    user
  } = messageObj
  const {
    common: { isMobile, isDesktop }
  } = useSelector((state) => state)

  const localDate = convertToLocalDate(createdAt)
  const convertedTime = getTime(localDate)

  const cancleReply = (e) => {
    e.preventDefault()
    dispatch(messengerActions.setOriginMessage(null))
  }

  const handleScrollToMessage = () => {
    if (messageObj) {
      scrollToTarget(messageObj.message.id)
    }
  }

  return (
    <div className={`${styles.originMessageContainer} ${originMessageContainerCSS}`}>
      {/* <label className={styles.originMessageLabel}>{t('messenger.replyText')}</label> */}

      <div
        role='button'
        className={`${styles.container} ${messageContainerCSS} ${styles.replayMessage}`}
        onClick={handleScrollToMessage}
        // id={`scrollToMessage#${messageObj && messageObj.message.id}`}
      >
        {user ? (
          <React.Fragment>
            {isDesktop && (
              <Avatar
                imgWrapperSize='small'
                userId={user.id}
                profilePicture={user.profile_picture_url}
                firstname={user.firstname}
                lastname={user.lastname}
                mimeType={user.mime_type}
                originalTag={user.original_tag}
                isOriginal={user.is_original}
                withExpertiseGroup={user.with_expertise_group}
              />
            )}
            {isMobile && <Icon name='reply24' size='large24' styleModifier={styles.replyIcon} />}
            <div className={styles.content}>
              {isDesktop && <p className={styles.userName}>{`${user.firstname} ${user.lastname}`}</p>}
              <div className={styles.messageContainer}>
                {isDesktop && <span className={styles.time}>{convertedTime} </span>}
                {messageObj?.message?.files?.length > 0 ? (
                  <p className={styles.paperClipIcon}>
                    <Icon name='paperclip24' size='medium' />
                    {t('global.media')}
                  </p>
                ) : (
                  <p
                    className={styles.message}
                    dangerouslySetInnerHTML={{
                      __html: messageObj?.message?.message
                    }}
                  />
                )}
              </div>
            </div>
            {/* <button type='button' className={styles.closeReply} onClick={cancleReply}>
              <Icon name='close' />
            </button> */}
            <IconButton iconName='close24' className={styles.closeReply} onClick={cancleReply} />
          </React.Fragment>
        ) : (
          <p
            className={styles.message}
            dangerouslySetInnerHTML={{
              __html: messageObj && messageObj.message.message
            }}
          />
        )}
      </div>
    </div>
  )
}
